import React from 'react';
import { Handle, Position } from 'reactflow';
import './nodes.css';

const TeamNode = ({ data, selected }) => (
  <div className={`fnode fnode--team ${selected ? 'is-selected' : ''}`}>
    <div className="fnode__title">{data.name || 'Squadra'}</div>
    <Handle type="source" position={Position.Right} />
  </div>
);

export default TeamNode;
